import { Box, Button, Card, CardContent, Checkbox, Divider, Fade, Grid, Typography } from "@material-ui/core";
import { PessoaEnderecoModel } from "api/cardapio/models/pessoa/pessoa-model";
import React, { useEffect, useState } from "react"
import { FasesHeader } from "../../../components/fases-header/fases-header";
import { EnumOpcoesDelivery } from "storage";
import { useDadosDeliveryStore } from "services/store/dados-delivery";
import { useThemeQueries } from "theme/util-styles";
import { enderecoFormatado } from "utils/endereco-formatado";
import { useStyles } from "./selecionar-endereco-styles";
import { useEmpresaAtual } from "services/hooks/empresa";
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario";
import { ConfirmarIcon } from "components/icons/confirmar-icon";
import { NovoIcon } from "components/icons/novo-icon";
import { EditarIcon } from "components/icons/editar-icon";
import { useCardapioDadosStore } from "services/store/cardapio-dados-store";
import { TemaModel } from "api/cardapio/models/tema/tema-model";
import { guidEmpty } from "utils/guid-empty";

export type TSelecionarEnderecoProps = {
    setPreencherFormulario: (preencherFormulario: boolean) => void;
    setEndereco: (endereco: PessoaEnderecoModel | undefined) => void;
    voltar: () => void
    confirmarEndereco: (tipoDelivery: EnumOpcoesDelivery) => void
    enderecoSelecionado: PessoaEnderecoModel | undefined
    faseInformarEndereco: boolean
}

export const SelecionarEndereco = ({ setEndereco, setPreencherFormulario, voltar, confirmarEndereco, enderecoSelecionado, faseInformarEndereco }: TSelecionarEnderecoProps) => {
    const tipoDelivery = useDadosDeliveryStore(state => state.tipoDelivery)
    const { isMobile, theme } = useThemeQueries()
    const [selectOpcaoDelivery, setSelectOpcaoDelivery] = useState(() => tipoDelivery);
    const { getEmpresaAtual } = useEmpresaAtual()
    const pessoa = usePessoaUsuarioStore(state => state.pessoa)
    const { permiteEntrega, permiteRetirada } = useCardapioDadosStore(state => state.cardapioDados?.configuracoes || {} as TemaModel)
    const empresa = getEmpresaAtual()
    const classes = useStyles()

    useEffect(() => {
        if (permiteEntrega && (!enderecoSelecionado || enderecoSelecionado.id === guidEmpty()) && tipoDelivery !== EnumOpcoesDelivery.Retirada) {
            setSelectOpcaoDelivery(EnumOpcoesDelivery.Entrega)
            setEndereco(pessoa?.enderecos?.[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faseInformarEndereco])

    const clickEditarEndereco = (endereco: PessoaEnderecoModel) => {
        setEndereco(endereco)
        setPreencherFormulario(true)
    }

    return (
        <Fade in>
            <Box height={"100%"} width={"100%"} flex="1" display="flex" flexDirection="column">
                <FasesHeader titulo="Selecionar Endereço" voltar={voltar} />
                <Box flex="1" display="flex" flexDirection="column">
                    <Box flex={1} p={2} height="0" overflow="auto">
                        <Grid container spacing={2}>
                            {permiteRetirada && (
                                <>
                                    <Grid item xs={12}>
                                        <Box
                                            style={{
                                                alignItems: 'center',
                                                display: 'flex',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                setSelectOpcaoDelivery(EnumOpcoesDelivery.Retirada)
                                                setEndereco(undefined)
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Checkbox
                                                    color="primary"
                                                    checked={selectOpcaoDelivery === EnumOpcoesDelivery.Retirada}
                                                    style={{ marginLeft: !isMobile ? '5px' : 'unset' }}
                                                />
                                            </div>
                                            <div>
                                                <CardContent classes={{ root: classes.cardContentRoot }}>
                                                    <Typography variant="h5">Retirar no Local</Typography>
                                                    <Typography variant="body1">
                                                        {enderecoFormatado(
                                                            empresa?.logradouro || '',
                                                            empresa?.numero || '',
                                                            empresa?.bairro || '',
                                                            empresa?.municipio || '',
                                                            empresa?.uf || '',
                                                        )}
                                                    </Typography>
                                                </CardContent>
                                            </div>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                </>
                            )}
                            {permiteEntrega && (
                                <>
                                    <Grid item xs={12}>
                                        <Box mb={2}>
                                            <Typography variant="h6">
                                                Selecione o Endereço de Entrega
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    {pessoa?.enderecos.map((endereco, index) => (
                                        <Grid item xs={12} key={index}>
                                            <Card
                                                variant="outlined"
                                                style={{
                                                    display: 'flex',
                                                    border:
                                                        enderecoSelecionado?.id === endereco.id
                                                            ? `1px solid ${theme.palette.primary.main}`
                                                            : `1px solid ${theme.palette.primary.main}`,
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    minHeight: 60
                                                }}
                                                onClick={() => {
                                                    if (selectOpcaoDelivery !== EnumOpcoesDelivery.Entrega) {
                                                        setSelectOpcaoDelivery(EnumOpcoesDelivery.Entrega)
                                                    }
                                                    setEndereco(endereco)
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Checkbox
                                                        color="primary"
                                                        checked={enderecoSelecionado?.id === endereco.id}
                                                        style={{ marginLeft: !isMobile ? '5px' : 'unset' }}
                                                    />
                                                </div>
                                                <div>
                                                    <CardContent classes={{ root: classes.cardContentRoot }}>
                                                        <Typography variant="body1">
                                                            {enderecoFormatado(
                                                                endereco?.logradouro || '',
                                                                endereco?.numero || '',
                                                                endereco?.bairro || '',
                                                                endereco?.xMun || '',
                                                                endereco?.uf || '',
                                                                endereco?.complemento || '',
                                                                endereco?.cep || '',
                                                                endereco?.referencia || '',
                                                            )}
                                                        </Typography>
                                                    </CardContent>
                                                </div>
                                                <Button
                                                    variant="text"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        clickEditarEndereco(endereco)
                                                    }}
                                                >
                                                    <EditarIcon
                                                        tipo="BUTTON"
                                                    />
                                                </Button>
                                            </Card>
                                        </Grid>
                                    ))}
                                </>
                            )}
                        </Grid>
                    </Box>

                    <Box flex="0 0 auto" p={2} display="flex" flexDirection="column" gridGap={16}>
                        <Button
                            variant="outlined"
                            size="large"
                            color="primary"
                            fullWidth
                            onClick={() => {
                                setEndereco(new PessoaEnderecoModel())
                                setPreencherFormulario(true)
                            }}
                        >
                            <NovoIcon tipo="BUTTON" />
                            Novo endereço
                        </Button>
                        <Button
                            variant="contained"
                            disabled={selectOpcaoDelivery === undefined}
                            onClick={() => {
                                if (selectOpcaoDelivery === undefined) return
                                confirmarEndereco(selectOpcaoDelivery)
                            }}
                            color="primary"
                            fullWidth
                            size="large"
                        >
                            <ConfirmarIcon tipo="BUTTON_PRIMARY" />
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Fade>
    )
}